import { render } from "./AddUserLogDialog.vue?vue&type=template&id=04b08fca"
import script from "./AddUserLogDialog.vue?vue&type=script&lang=js"
export * from "./AddUserLogDialog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__